var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgUndrawRelaxedReadingWfkr(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 924.828,
    height: 641.181,
    viewBox: "0 0 924.828 641.181",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    role: "img",
    artist: "Katerina Limpitsouni",
    source: "https://undraw.co/",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_38",
    "data-name": "Group 38",
    transform: "translate(-518.523 -233.926)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_568-1653",
    "data-name": "Path 568",
    d: "M265.274,678.706S147.642,624.554,188.966,587,265.274,678.706,265.274,678.706Z",
    transform: "translate(361.027 110.69)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_569-1654",
    "data-name": "Path 569",
    d: "M260.278,693.981S206.21,516.33,285.827,524.826,260.278,693.981,260.278,693.981Z",
    transform: "translate(363.975 108.052)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_570-1655",
    "data-name": "Path 570",
    d: "M221.829,671.266l2.269,29.717.036.513a136.548,136.548,0,0,0,.7,13.9c3.08,30.311,16.317,44.125,31.788,44.125s28.132-13.814,31.212-44.126a136.537,136.537,0,0,0,.7-13.9l.018-.414.009-.1,2.278-29.717Z",
    transform: "translate(363.003 115.011)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_571-1656",
    "data-name": "Path 571",
    d: "M288.464,699.637l-.009.1-.018.414a136.555,136.555,0,0,1-.7,13.9h-63a136.529,136.529,0,0,1-.7-13.9l-.036-.513Z",
    transform: "translate(363.105 116.357)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_572-1657",
    "data-name": "Path 572",
    d: "M996.892,695.05s-91.073-41.926-59.079-71S996.892,695.05,996.892,695.05Z",
    transform: "translate(396.638 112.52)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_573-1658",
    "data-name": "Path 573",
    d: "M993.024,706.875s-41.861-137.54,19.781-130.962S993.024,706.875,993.024,706.875Z",
    transform: "translate(398.921 110.478)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_574-1659",
    "data-name": "Path 574",
    d: "M963.256,689.289l1.757,23.008.028.4a105.7,105.7,0,0,0,.544,10.758c2.384,23.468,12.633,34.163,24.611,34.163s21.781-10.7,24.165-34.163a105.684,105.684,0,0,0,.544-10.758l.014-.321.007-.077,1.764-23.008Z",
    transform: "translate(398.167 115.866)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_575-1660",
    "data-name": "Path 575",
    d: "M1014.846,711.255l-.007.077-.014.321a105.684,105.684,0,0,1-.544,10.758H965.505a105.683,105.683,0,0,1-.544-10.758l-.028-.4Z",
    transform: "translate(398.247 116.908)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_576-1661",
    "data-name": "Path 576",
    d: "M451.762,328.343V287.926h-6.285v40.417a8.379,8.379,0,1,0,6.285,0Z",
    transform: "translate(373.361 96.83)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_577-1662",
    "data-name": "Path 577",
    d: "M471.643,739.546H428.7V217.926H411.94v521.62H369A38.755,38.755,0,0,0,330.241,778.3H510.4a38.755,38.755,0,0,0-38.755-38.755Z",
    transform: "translate(368.144 93.51)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_578-1663",
    "data-name": "Path 578",
    d: "M330.324,298.945H510.307L499.3,161.376a19.061,19.061,0,0,0-18.9-17.45H360.231a19.061,19.061,0,0,0-18.9,17.45Z",
    transform: "translate(368.148 90)",
    fill: "#2553c5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_579-1664",
    "data-name": "Path 579",
    d: "M570.485,522.454h0a12.957,12.957,0,0,0-14.934,10.829l-5.067,33.254,17.241,4.573,12.633-30.984a12.957,12.957,0,0,0-9.872-17.673Z",
    transform: "translate(378.59 107.945)",
    fill: "#ffb9b9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_580-1665",
    "data-name": "Path 580",
    d: "M574.718,564.927c9.568,38.024,5.45,72.8-30.179,100.109-42.734-11.78-71.157-40.2-88.5-81.509a20.618,20.618,0,0,1,11.891-27.33h0a20.607,20.607,0,0,1,22.686,5.847l41.93,48.4,19.67-48.8Z",
    transform: "translate(374.035 109.493)",
    fill: "#2553c5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_581-1666",
    "data-name": "Path 581",
    d: "M781.443,757.4c-39.02-2.073-63.26-15.471-69.13-42.945l6.285-11.522,71.953,32.778a10.064,10.064,0,0,1-.708,18.608Z",
    transform: "translate(386.265 116.513)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_582-1667",
    "data-name": "Path 582",
    d: "M753.521,758.054c-20.274-.614-39.771-.423-58.246.827a12.34,12.34,0,0,1-13.142-11.329l-1.109-13.865-15.711-25.138,13.617-13.617c22.883,22.791,47.979,41.934,77.785,53.314a5.375,5.375,0,0,1-3.193,9.807Z",
    transform: "translate(384.036 116.134)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_583-1668",
    "data-name": "Path 583",
    d: "M652.447,663.377C626.558,709.7,601.1,740.929,567.6,757.646c-41.2,13.6-71.32-4.418-94.792-41.373L540.9,671.233l9.951,9.951,90.182-68.626a11.515,11.515,0,0,1,16.2.36l76.921,94.451-9.427,15.711Z",
    transform: "translate(374.906 112.077)",
    fill: "#090814"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_584-1669",
    "data-name": "Path 584",
    d: "M509.4,572.185l-35.613-54.466,8.379-15.712L529.3,551.236Z",
    transform: "translate(540.995 257.736)",
    fill: "#090814",
    opacity: 0.798
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_585-1670",
    "data-name": "Path 585",
    d: "M481.115,577.972l-39.8-13.617a49.433,49.433,0,0,0,7.332-31.423h32.47C479.268,548.914,478.991,564.073,481.115,577.972Z",
    transform: "translate(373.412 108.45)",
    fill: "#ffb9b9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_586-1671",
    "data-name": "Path 586",
    d: "M557.156,689.619c-5.967,2.45,3.448-7.028-2.195-4.329-27.275,13.05-56.131,23.638-75.939,42.421-46.289-31.433-89.193-129.062-33.518-171.778,19,11.121,35.98,19.079,35.613,0Z",
    transform: "translate(372.362 109.541)",
    fill: "#2553c5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_587-1672",
    "data-name": "Path 587",
    d: "M542.538,628.892l-19.377-6.808-38.231,29.852-17.138-61.7c-1.189-4.279-3.115-2.11-5.88.862a20.6,20.6,0,0,0-34.568,14.2C425.3,650.054,438.8,687.915,472.36,716.876c43.895-9.4,62.523-39.055,70.178-77.51l-2.075-1.383Q541.61,633.526,542.538,628.892Z",
    transform: "translate(372.74 110.949)",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_589-1673",
    "data-name": "Path 589",
    d: "M380.285,441.121l32.593,38.318,48.89-57.7-33.034-40.081Z",
    transform: "translate(536.56 252.028)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_590-1674",
    "data-name": "Path 590",
    d: "M610.368,566.721l-38.759-31.712c2.2-5.285,12.773-3.524,12.773-3.524l30.34,30.759a16.6,16.6,0,0,1,2.693,3.6h0Z",
    transform: "translate(379.592 108.368)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_591-1675",
    "data-name": "Path 591",
    d: "M614.5,564.566l-44.045-34.355-48.89,74L567.6,635.258c4.4,1.762,8.809-1.321,8.809-1.321l44.926-68.71Z",
    transform: "translate(377.219 108.321)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_195",
    "data-name": "Rectangle 195",
    width: 0.714,
    height: 34.715,
    transform: "matrix(0.584, -0.812, 0.812, 0.584, 952.756, 649.837)",
    fill: "#2553c5"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_196",
    "data-name": "Rectangle 196",
    width: 67.065,
    height: 0.714,
    transform: "matrix(0.552, -0.834, 0.834, 0.552, 944.741, 733.032)",
    fill: "#2553c5"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_197",
    "data-name": "Rectangle 197",
    width: 0.714,
    height: 37.175,
    transform: "translate(910.468 713.251) rotate(-53.656)",
    fill: "#2553c5"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_198",
    "data-name": "Rectangle 198",
    width: 67.078,
    height: 0.714,
    transform: "translate(909.507 705.278) rotate(-55.162)",
    fill: "#2553c5"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_199",
    "data-name": "Rectangle 199",
    width: 0.44,
    height: 47.306,
    transform: "translate(959.366 639.742) rotate(-47.455)",
    fill: "#b3b3b3"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_200",
    "data-name": "Rectangle 200",
    width: 0.441,
    height: 48.589,
    transform: "translate(956.469 640.022) rotate(-48.561)",
    fill: "#b3b3b3"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_201",
    "data-name": "Rectangle 201",
    width: 0.441,
    height: 49.227,
    transform: "matrix(0.64, -0.768, 0.768, 0.64, 954.197, 640.671)",
    fill: "#b3b3b3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_592-1676",
    "data-name": "Path 592",
    d: "M557.28,593.2h0a12.956,12.956,0,0,0-18.135,3.382l-18.833,27.872,13.617,11.522L558.624,613.4a12.957,12.957,0,0,0-1.344-20.2Z",
    transform: "translate(377.159 111.198)",
    fill: "#ffb9b9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_593-1677",
    "data-name": "Path 593",
    d: "M542.538,633.367c-7.654,38.455-26.283,68.111-70.178,77.51C438.8,681.915,425.3,644.053,427.343,599.3A20.617,20.617,0,0,1,449.8,579.706h0a20.607,20.607,0,0,1,17.99,15.007l17.138,61.7,38.689-35.656Z",
    transform: "translate(372.74 110.664)",
    fill: "#2553c5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_594-1678",
    "data-name": "Path 594",
    d: "M924.415,612.252H0v-2.285H924.828Z",
    transform: "translate(518.523 262.856)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_595-1679",
    "data-name": "Path 595",
    d: "M619.907,235.433a2.1,2.1,0,0,0-2.095,2.095v163.4a2.1,2.1,0,0,0,2.095,2.095H756.073a2.1,2.1,0,0,0,2.095-2.095v-163.4a2.1,2.1,0,0,0-2.095-2.095Z",
    transform: "translate(381.784 94.34)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_596-1680",
    "data-name": "Path 596",
    d: "M633.313,386.051H741.2V250.933H633.313Z",
    transform: "translate(382.519 95.075)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_597-1681",
    "data-name": "Path 597",
    d: "M836.3,276.433a1.252,1.252,0,0,0-1.251,1.251v81.293a1.252,1.252,0,0,0,1.251,1.251h97.552a1.252,1.252,0,0,0,1.251-1.251V277.684a1.252,1.252,0,0,0-1.251-1.251Z",
    transform: "translate(392.087 96.285)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_598-1682",
    "data-name": "Path 598",
    d: "M844.305,285.687V350.1h80.668V285.687Z",
    transform: "translate(392.526 96.724)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_599-1683",
    "data-name": "Path 599",
    d: "M704.962,248.4h-38.1a5.225,5.225,0,0,1-4.535-7.856l19.049-32.994.048-.081a5.175,5.175,0,0,1,3.966-2.512l.028,0c.163-.015.328-.023.494-.023a5.184,5.184,0,0,1,4.535,2.619L709.5,240.546a5.237,5.237,0,0,1-4.535,7.856Zm-39.15-5.242a1.077,1.077,0,0,0,.144.529,1.03,1.03,0,0,0,.907.524h38.1a1.029,1.029,0,0,0,.907-.524,1.076,1.076,0,0,0,.144-.528,1.031,1.031,0,0,0-.144-.519L686.82,209.646a1.048,1.048,0,0,0-1.815,0L665.956,242.64A1.028,1.028,0,0,0,665.812,243.159Z",
    transform: "translate(383.861 92.893)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_91",
    "data-name": "Ellipse 91",
    cx: 3.142,
    cy: 3.142,
    r: 3.142,
    transform: "translate(1066.631 301.492)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_600-1684",
    "data-name": "Path 600",
    d: "M893.737,280H873.081a2.833,2.833,0,0,1-2.459-4.259l10.328-17.888.026-.044a2.806,2.806,0,0,1,2.15-1.362h.015c.088-.008.178-.012.268-.012a2.811,2.811,0,0,1,2.459,1.42L896.2,275.741A2.84,2.84,0,0,1,893.737,280Zm-21.226-2.842a.582.582,0,0,0,.078.287.558.558,0,0,0,.492.284h20.656a.558.558,0,0,0,.492-.284.584.584,0,0,0,.078-.286.56.56,0,0,0-.078-.281L883.9,258.988a.568.568,0,0,0-.984,0l-10.328,17.888a.556.556,0,0,0-.078.281Z",
    transform: "translate(393.756 95.336)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_92",
    "data-name": "Ellipse 92",
    cx: 1.704,
    cy: 1.704,
    r: 1.704,
    transform: "translate(1275.461 353.757)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_601-1685",
    "data-name": "Path 601",
    d: "M634.633,331.72a27.747,27.747,0,0,1,15.986-15.007,27.423,27.423,0,0,1,22.846,1.421c8.174,4.338,14.708,11.158,23.01,15.31a58.843,58.843,0,0,0,25.962,6.116A58.11,58.11,0,0,0,751.548,332a1.572,1.572,0,0,0-1.586-2.713,55.874,55.874,0,0,1-52.822.969c-8.328-4.367-14.927-11.418-23.411-15.509a30.249,30.249,0,0,0-23.285-1.307A31.261,31.261,0,0,0,631.6,330.884c-.762,1.872,2.276,2.686,3.03.835Z",
    transform: "translate(382.432 97.958)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_602-1686",
    "data-name": "Path 602",
    d: "M632.209,359.31a119.62,119.62,0,0,1,52.937.183c15.467,3.587,31.433,10.04,47.379,5.227,7.124-2.15,13.654-6.451,17.314-13.069.979-1.771-1.733-3.358-2.713-1.586-6.891,12.461-23.036,14.564-35.787,12.519-8.52-1.366-16.731-4.106-25.118-6.066a122.421,122.421,0,0,0-54.848-.239C629.4,356.721,630.236,359.751,632.209,359.31Z",
    transform: "translate(382.373 99.74)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_603-1687",
    "data-name": "Path 603",
    d: "M631.129,292.02a124.255,124.255,0,0,1,50.321,1.79c15.392,3.771,30.437,12.387,46.712,10.9,7.535-.689,14.995-3.46,20.113-9.224,1.339-1.508-.876-3.738-2.222-2.222-4.416,4.973-10.776,7.55-17.3,8.246-7.522.8-14.913-.756-22.073-2.97-7.925-2.451-15.624-5.556-23.682-7.582a127.261,127.261,0,0,0-52.7-1.966c-1.989.34-1.146,3.368.835,3.03Z",
    transform: "translate(382.322 96.792)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_604-1688",
    "data-name": "Path 604",
    d: "M857.737,284.8a54.78,54.78,0,0,1,14.373,26.8,54.1,54.1,0,0,1-11.7,45.941c-1.3,1.533.91,3.766,2.222,2.222a58.042,58.042,0,0,0,13.3-30.033,57.287,57.287,0,0,0-15.976-47.153c-1.418-1.446-3.64.776-2.222,2.222Z",
    transform: "translate(393.141 96.554)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_605-1689",
    "data-name": "Path 605",
    d: "M903.445,278.285c-9.63,7.063-15.021,18.463-15.78,30.255-.789,12.269,3.89,24.118,11.425,33.644a65.423,65.423,0,0,0,15.553,14.039c1.7,1.11,3.273-1.609,1.586-2.713-9.62-6.295-17.852-15.236-22.224-25.967a42.019,42.019,0,0,1-.091-32.2A34.4,34.4,0,0,1,905.031,281c1.614-1.184.048-3.912-1.586-2.713Z",
    transform: "translate(394.578 96.358)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_93",
    "data-name": "Ellipse 93",
    cx: 14.664,
    cy: 14.664,
    r: 14.664,
    transform: "translate(1062.442 376.907)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_37",
    "data-name": "Group 37",
    transform: "matrix(0.998, 0.07, -0.07, 0.998, 750.377, 536.361)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_66",
    "data-name": "Ellipse 66",
    cx: 36.302,
    cy: 36.302,
    rx: 36.302,
    ry: 36.302,
    transform: "translate(62.71 40.889)",
    fill: "#ffb9b9"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_67",
    "data-name": "Ellipse 67",
    cx: 32.115,
    cy: 32.115,
    rx: 32.115,
    ry: 32.115,
    transform: "translate(9.987 0)",
    fill: "#090814"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_417-1690",
    "data-name": "Path 417",
    d: "M14.4,30.033A32.118,32.118,0,0,0,63.986,13.17,32.118,32.118,0,1,1,1.338,0,32.106,32.106,0,0,0,14.4,30.033Z",
    transform: "translate(0 28.676)",
    fill: "#090814"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_418-1691",
    "data-name": "Path 418",
    d: "M89.067,25.4C83.461,15.366,81.316,11.178,74.087,5.063c-6.393-5.4-14.256-6.983-20.6-1.869A38.2,38.2,0,1,0,76.146,33.77C81.66,33,83.554,26.181,89.067,25.4Z",
    transform: "translate(52.075 33.338)",
    fill: "#090814"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUndrawRelaxedReadingWfkr);
export default __webpack_public_path__ + "static/media/undraw_relaxed-reading_wfkr.eba8c7453d25e353be48b13a4b5ca554.svg";
export { ForwardRef as ReactComponent };